import { render, staticRenderFns } from "./ModalNovaCampanha.vue?vue&type=template&id=36452aa1&scoped=true"
import script from "./ModalNovaCampanha.vue?vue&type=script&lang=js"
export * from "./ModalNovaCampanha.vue?vue&type=script&lang=js"
import style0 from "./ModalNovaCampanha.vue?vue&type=style&index=0&id=36452aa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36452aa1",
  null
  
)

export default component.exports